module.exports = {"settings":{"nameEn":"Name En","nameTh":"Name Th","address":"Address","email":"E-mail","groupName":"Name","groupCode":"Code","groupDescription":"Description","stationIds":"Station","firstName":"First Name","lastName":"Last Name","age":"Age","password":"Password","userGroupId":"User Group","companyId":"Company","siteId":"Site","station":"Station","add":"Add","stationName":"Station Name","siteName":"Site Name","status":"Status"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/settings.json
// module id = 112
// module chunks = 35